import { render, staticRenderFns } from "./TapdanceKey.vue?vue&type=template&id=653f775d&"
import script from "./TapdanceKey.vue?vue&type=script&lang=js&"
export * from "./TapdanceKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports